<unity-card-summary-shared>
  <h4>Duration in Program</h4>
  <h3>{{ $agreementDuration() }}</h3>
  <kendo-gridlayout gap="0.5rem" [cols]="['1fr', '1em', '1fr']" [align]="{ horizontal: 'center', vertical: 'bottom' }">
    @let client = $client();
    @if (client) {
      <kendo-gridlayout-item class="k-justify-self-end">
        <div class="k-text-center">
          <h6>Start Date</h6>
          <h6>{{ client.start_date | dateTimezone: 'M/d/yy' }}</h6>
        </div>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item />
      <kendo-gridlayout-item class="k-justify-self-start">
        <div class="k-text-center">
          <h6>End Date</h6>
          @if (!client.end_date) {
            <h6>N/A</h6>
          } @else {
            <h6>{{ client.end_date | dateTimezone: 'M/d/yy' }}</h6>
          }
        </div>
      </kendo-gridlayout-item>
    }
  </kendo-gridlayout>
</unity-card-summary-shared>
